import { getLLTtoken } from "@/utility/getLLT";
import mocks from "./mocks";
import { ERRORTYPES } from "@/errors"
import Sentry from "@/utility/errorTracking";
import { navigateToSSO } from "@/utility/navigate";

const isTesting = false;
const MOCK_RESPONSE_DELAY = 5000;

export const api = async (uri, options = {}, base = null) => {  
  return new Promise((resolve, reject) => {
    // TODO: Add semaphore check > one active request at a time?
    // TODO: Add caching
    // TODO: Add options preprocessor
    // options.mode = "no-cors";
    // TODO: Remove mocks

      const token = getLLTtoken()

      const httpHeaders = {
        method: options.method || "GET",
        headers: {
          ...options.headers,
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      };

    if (isTesting && Object.hasOwn(mocks, uri)) {
      setTimeout(() => resolve(mocks[uri]), MOCK_RESPONSE_DELAY);
    } else {
      if (!base) {
        base = import.meta.env.VITE_BFF_API_BASE;
      }
      fetch(base + uri, options.tokenRequired && httpHeaders)
        .then(async(response) => {

          if(options.responseHandler){
            await options.responseHandler(response)
          }
          else{
            if (!response.ok) {
              let error = {
                name: ERRORTYPES.NETWORK,
                message: "Network API Failed",
                status: response.status,
              }
              
              if(response.status === 401) {
                error.name = ERRORTYPES.UNAUTHORIZED
                error.message = "Unauthorized user"
              }
  
              Sentry.captureException(error.message);
              throw error
            }
          }
          return response.json();

        })
        .then((response) => {
          resolve(response);
          // if (response.status) {
          //   resolve(response.data);
          // } else {
          //   reject(response);
          // }
        })
        .catch((error) => {
          if(error?.status === 401){
            navigateToSSO()
          }

          if(error instanceof Error){
            Sentry.captureException(error);
          } else {
            const errObj = new Error(typeof error === "object" ? JSON.stringify(error) : String(error));
            Sentry.captureException(errObj);
          }

          reject(error);
        });
    }
  });
};
